import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { RootVariable } from './constant.js';

var getLgSizeStyles = function getLgSizeStyles() {
  return {
    wrapper: _defineProperty({}, RootVariable.INPUT_HEIGHT, '44px')
  };
};
var useInputAppStyle = function useInputAppStyle(_ref) {
  var size = _ref.size;
  return _objectSpread2({}, size === 'lg' ? getLgSizeStyles() : {});
};

export { useInputAppStyle };
//# sourceMappingURL=Input.app.style.js.map
